<template>
  <div class="c-requestAddNavigation">
    <div class="c-requestAddNavigation_title">
      入力項目・状況
    </div>
    <ul class="c-requestAddNavigation_list">
      <li>
        <a
          class="c-requestAddNavigation_listItem"
          :class="{ 'c-requestAddNavigation_listItem-done': isValidCategory }"
          href="#"
          v-scroll-to="{ el: '#requestAddContentsCategory', offset: scrollToOffset }"
        >
          <span>
            <coconala-icon
              name="chevron-left"
              size="12px"
            />
            カテゴリ選択
          </span>
          <span>
            <coconala-icon
              name="check-circle"
              size="16px"
            />
          </span>
        </a>
      </li>
      <li>
        <a
          class="c-requestAddNavigation_listItem"
          :class="{ 'c-requestAddNavigation_listItem-done': isValidDetail }"
          href="#"
          v-scroll-to="{ el: '#requestAddContentsDetail', offset: scrollToOffset }"
        >
          <span>
            <coconala-icon
              name="chevron-left"
              size="12px"
            />
            依頼の内容
          </span>
          <span>
            <coconala-icon
              name="check-circle"
              size="16px"
            />
          </span>
        </a>
      </li>
      <li>
        <a
          class="c-requestAddNavigation_listItem"
          :class="{ 'c-requestAddNavigation_listItem-done': isValidPrice }"
          href="#"
          v-scroll-to="{ el: '#requestAddContentsPrice', offset: scrollToOffset }"
        >
          <span>
            <coconala-icon
              name="chevron-left"
              size="12px"
            />
            予算
          </span>
          <span>
            <coconala-icon
              name="check-circle"
              size="16px"
            />
          </span>
        </a>
      </li>
      <li>
        <a
          class="c-requestAddNavigation_listItem"
          :class="{ 'c-requestAddNavigation_listItem-done': isValidDate }"
          href="#"
          v-scroll-to="{ el: '#requestAddContentsDate', offset: scrollToOffset }"
        >
          <span>
            <coconala-icon
              name="chevron-left"
              size="12px"
            />
            期限
          </span>
          <span>
            <coconala-icon
              name="check-circle"
              size="16px"
            />
          </span>
        </a>
      </li>
    </ul>
    <div class="c-requestAddNavigation_count">
      入力が必要な必須項目数は、<br>
      残り <strong>{{ remainingCount }}</strong> です。
    </div>
  </div>
</template>
<script>
const scrollToOffset = -160

export default {
  name: 'RequestAddNavigation',
  props: {
    isValidCategory: {
      type: Boolean,
      default: false
    },
    isValidDetail: {
      type: Boolean,
      default: false
    },
    isValidPrice: {
      type: Boolean,
      default: false
    },
    isValidDate: {
      type: Boolean,
      default: false
    },
    remainingCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      scrollToOffset
    }
  }
}
</script>
<style lang="scss" scoped>
.c-requestAddNavigation {
  position: sticky;
  top: 160px;
  padding: 20px 12px;
  border: 1px solid $color-gray-200;
  background-color: $color-white;

  &_title {
    padding-bottom: 12px;
    border-bottom: 1px solid $color-gray-50;
    color: $color-gray-700;
    font-weight: bold;
    font-size: 12px;
    line-height: 1;
  }

  &_list {
    padding: 8px;
  }

  &_listItem {
    @include link-effect;

    display: flex;
    color: $color-blue-500;
    line-height: 34px;
    cursor: pointer;

    justify-content: space-between;

    .-chevron-left {
      color: $color-gray-300;
      vertical-align: -1px;
    }

    .-check-circle {
      color: $color-gray-200;
    }

    &-done {
      color: $color-gray-900;

      .-chevron-left {
        color: $color-gray-700;
      }

      .-check-circle {
        color: $color-green-500;
      }
    }
  }

  &_count {
    padding: 6px 12px;
    border-radius: 6px;
    background-color: $color-gray-50;
    white-space: nowrap;
    font-weight: bold;
    font-size: 12px;
    line-height: 20px;

    strong {
      color: $color-red-500;
      font-size: 16px;
    }
  }
}
</style>
